module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Remetschwil_AG-c5c3ccc9a2b1813cf42eaa78540fd0c4.svg";